"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _app = require("@/api/base/app");
var _app2 = require("@/utils/app");
var state = {
  appList: [],
  appName: '',
  curPid: (0, _app2.getCurPid)(),
  curPlatform: ''
};
var mutations = {
  SET_APP_LIST: function SET_APP_LIST(state, appList) {
    state.appList = appList;
  },
  SET_CUR_PID: function SET_CUR_PID(state, _ref) {
    var pid = _ref.pid,
      platform = _ref.platform,
      appName = _ref.appName;
    (0, _app2.setCurPid)(pid);
    state.curPid = pid;
    state.curPlatform = platform;
    state.appName = appName;
  }
};
var actions = {
  // user login
  getAppList: function getAppList(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      (0, _app.getAppList)({
        limit: 100,
        page: 1
      }).then(function (response) {
        var data = response.data;
        commit('SET_APP_LIST', data.list);
        // 默认区APP列表第一个为当前APP
        if (data.list.length > 0) {
          var pid = data.list[0]['pid'];
          var platform = data.list[0]['platform'];
          var appName = data.list[0]['app_name'];
          if (!state.curPid) {
            commit('SET_CUR_PID', {
              pid: pid,
              platform: platform,
              appName: appName
            });
          } else {
            var curPid = parseInt(state.curPid);
            data.list.forEach(function (item) {
              if (parseInt(item['pid']) === curPid) {
                var _pid = item['pid'];
                var _platform = item['platform'];
                var _appName = item['app_name'];
                commit('SET_CUR_PID', {
                  pid: _pid,
                  platform: _platform,
                  appName: _appName
                });
              }
            });
          }
        }
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setCurPid: function setCurPid(_ref3, pid) {
    var commit = _ref3.commit;
    var platform = 1000;
    var appName = '';
    state.appList.forEach(function (item) {
      if (item['pid'] === pid) {
        platform = item['platform'];
        appName = item['app_name'];
      }
    });
    commit('SET_CUR_PID', {
      pid: pid,
      platform: platform,
      appName: appName
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;